import { Area, XAxis, YAxis, ResponsiveContainer, Tooltip, AreaChart } from 'recharts';
import './NewUsersGraph.css'

const NewUsersGraph = ({ graphData }) => {

    return (
        <div className='graph_container'>
            <div className='graph_header'>
                <h3 className='graph_title'>Volume de trade / margin :</h3>
                <div>
                    Mensuel
                </div>
            </div>
            <ResponsiveContainer width="100%" height={350}>
                <AreaChart width={800} height={350} data={graphData}>
                    <XAxis dataKey="day" />
                    <YAxis dataKey="volume" yAxisId="left" orientation='left' tickLine={false} />
                    <YAxis dataKey="margin_volume" yAxisId="right" orientation='right' tickLine={false}/>
                    <Tooltip />
                    <Area type="monotone" dataKey="volume" yAxisId="left" stroke="var(--primary)" fill="transparent" strokeWidth={3} />
                    <Area type="monotone" dataKey="margin_volume" yAxisId="right" stroke="var(--danger)" fill="transparent" strokeWidth={3} />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    )
}

export default NewUsersGraph
